module.exports = __webpack_public_path__ + "img/DE03953.d06bba23.png";